import { handleAction } from 'redux-actions';

import * as actions from '../actions';

const InitialState = [];

export const artProductsReducer = handleAction(
  actions.fetchArtProductsDone,
  (state, { payload: artProducts }) => artProducts,
  InitialState
);
